import { useEffect } from "react"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { NavStep } from "../../app-core/v3/_common/nav-step"
import { BookingSteps } from "../../app-core/_common/steps/booking-steps"

export const useSetActiveStep = (activeStep: BookingSteps, steps: NavStep<BookingSteps>[]) => {
    const [, send] = useECommerceMachine()
    const step = steps.find((step) => step.id === activeStep)
    const isStepReady = step && step.canGoto()

    useEffect(() => {
        send({ type: "SET_ACTIVE_STEP", activeStep: activeStep })
    }, [activeStep, send])

    useEffect(() => {
        if (isStepReady) send({ type: "ACTIVE_STEP_READY", activeStep: activeStep })
    }, [isStepReady, activeStep, send])
}
